<script lang="ts" setup>
import { useRouter } from 'vue-router';

import { useBroadcast } from '~/stores/broadcast.store';

const router = useRouter();
const broadcastStore = useBroadcast();

const toStats = () => {
  router.push({ name: 'statistics' });
  broadcastStore.setVisibleSentModal(false);
  broadcastStore.reset();
};
</script>

<template>
  <el-dialog
    :model-value="broadcastStore.getVisibleSentModal"
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    width="560px"
  >
    <div class="dialog">
      <div class="dialog-header">
        <p class="title">{{ $t('broadcast.modal.successSent.title') }}</p>
      </div>

      <div class="dialog-info">
        <p class="description">{{ $t('broadcast.modal.successSent.description one') }}</p>
        <p class="description">{{ $t('broadcast.modal.successSent.description two') }}</p>
      </div>

      <div class="dialog-footer">
        <BaseButton variant="primary" @click="toStats">
          {{ $t('broadcast.modal.successSent.buttons.toStat') }}
        </BaseButton>
      </div>
    </div>
  </el-dialog>
</template>

<style lang="scss" scoped>
.dialog {
  padding: 24px;

  &-header {
    .title {
      font-weight: 500;
      font-size: 24px;
      line-height: 32px;
      color: $typography-title;
    }
  }

  &-info {
    margin-top: 18px;

    .description {
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: $typography-secondary-color;
    }
  }

  &-footer {
    margin-top: 26px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
